const education = [
    {
        degree: 'B.Sc. in Computer Science and Engineering',
        timeline: '2019 – 2025',
        year: 2025,
        institution:
            'Bangladesh University of Engineering and Technology (BUET)',
        major: 'Computer Science and Engineering',
        result: 'CGPA: 3.98 / 4.00 (Rank: 6 / 137)',
    },
    {
        degree: 'Higher Secondary Certificate (HSC)',
        timeline: '2017 – 2019',
        year: 2019,
        institution: 'Notre Dame College, Dhaka',
        major: 'Science',
        result: 'GPA: 5.00 / 5.00',
    },
    {
        degree: 'Secondary School Certificate (SSC)',
        timeline: '2015 – 2017',
        year: 2017,
        institution: 'St. Joseph Higher Secondary School, Dhaka',
        major: 'Science',
        result: 'GPA: 5.00 / 5.00',
    },
];

export default education;
